"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = require("axios");
var json = require("common/infra/json");
var storage = require("common/infra/storage");
var firebase = require("firebase");
var ItemsRepository = /** @class */ (function () {
    function ItemsRepository(name, done) {
        var _this = this;
        this.name = name;
        this.done = done;
        this.get = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, _b, _c, _d, _e, error_1;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        _f.trys.push([0, 3, , 4]);
                        _b = (_a = json).decode;
                        _c = Buffer.bind;
                        _e = (_d = axios_1.default).get;
                        return [4 /*yield*/, this.reference.getDownloadURL()];
                    case 1: return [4 /*yield*/, _e.apply(_d, [_f.sent(), { responseType: "arraybuffer" }])];
                    case 2: return [2 /*return*/, _b.apply(_a, [new (_c.apply(Buffer, [void 0, (_f.sent()).data]))()])];
                    case 3:
                        error_1 = _f.sent();
                        if (error_1.code === "storage/object-not-found") {
                            console.error(error_1);
                            return [2 /*return*/, []];
                        }
                        else {
                            throw error_1;
                        }
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        this.set = function (items) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.reference.put(json.encode(items))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
    }
    Object.defineProperty(ItemsRepository.prototype, "reference", {
        get: function () {
            return firebase.storage().ref(this.path);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ItemsRepository.prototype, "path", {
        get: function () {
            return storage.itemsPath(this.name, this.done, firebase.auth().currentUser.uid);
        },
        enumerable: true,
        configurable: true
    });
    return ItemsRepository;
}());
exports.default = ItemsRepository;



//////////////////
// WEBPACK FOOTER
// ./src/infra/items-repository.ts
// module id = 445
// module chunks = 0